var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 17,
    viewBox: "0 0 12 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 3.825C6.56832 3.825 7.11337 4.04888 7.51523 4.4474C7.91709 4.84591 8.14286 5.38642 8.14286 5.95C8.14286 6.22906 8.08743 6.50539 7.97974 6.7632C7.87205 7.02102 7.71421 7.25528 7.51523 7.4526C7.31625 7.64993 7.08002 7.80645 6.82004 7.91324C6.56005 8.02004 6.2814 8.075 6 8.075C5.43168 8.075 4.88663 7.85112 4.48477 7.4526C4.08291 7.05409 3.85714 6.51359 3.85714 5.95C3.85714 5.38642 4.08291 4.84591 4.48477 4.4474C4.88663 4.04888 5.43168 3.825 6 3.825ZM6 0C7.5913 0 9.11742 0.626873 10.2426 1.74271C11.3679 2.85856 12 4.37196 12 5.95C12 10.4125 6 17 6 17C6 17 0 10.4125 0 5.95C0 4.37196 0.632141 2.85856 1.75736 1.74271C2.88258 0.626873 4.4087 0 6 0ZM6 1.7C4.86336 1.7 3.77327 2.14777 2.96954 2.9448C2.16582 3.74183 1.71429 4.82283 1.71429 5.95C1.71429 6.8 1.71429 8.5 6 14.2035C10.2857 8.5 10.2857 6.8 10.2857 5.95C10.2857 4.82283 9.83418 3.74183 9.03046 2.9448C8.22673 2.14777 7.13664 1.7 6 1.7Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.b0aa16a96f75e8498d01686126e37382.svg";
export { ForwardRef as ReactComponent };